import type { FieldReadFunction } from '@apollo/client'
import { format } from 'date-fns'
import { toUtcWallClock } from 'lib/helpers/toUtcWallClock/toUtcWallClock'
import { OutboundOrderSourceEnum } from 'gql/types'

/**
 * Reads an outbound order date field, narrowing manually-created orders down to their UTC calendar date.
 *
 * Integration-sourced orders keep their raw timestamp so the upstream value round-trips untouched.
 */
export const readManualOrderDate: FieldReadFunction<Maybe<string>> = (existing, { readField }) => {
  if (existing && readField('source') === OutboundOrderSourceEnum.MANUAL) {
    return format(toUtcWallClock(new Date(existing)), 'yyyy-MM-dd')
  }

  return existing
}
